import type { LanguageType } from '@milestone-portal/utils/i18n';

import { LanguageMenu as BaseLanguageMenu } from '@dvb/ui';
import dayjs from 'dayjs';

interface Props {
  isIconOnly?: boolean;
}

export function LanguageMenu({ isIconOnly = false }: Props) {
  const onSelect = (type: LanguageType) => {
    dayjs.locale(type.toLowerCase());
  };

  return <BaseLanguageMenu isIconOnly={isIconOnly} onSelect={onSelect} />;
}
